import { render, staticRenderFns } from "./TicketChat.vue?vue&type=template&id=03b9a50a&scoped=true&"
import script from "./TicketChat.vue?vue&type=script&lang=js&"
export * from "./TicketChat.vue?vue&type=script&lang=js&"
import style0 from "./TicketChat.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TicketChat.vue?vue&type=style&index=1&id=03b9a50a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b9a50a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VFileInput,VIcon,VListItemAvatar,VTextField})
